<script>
  import { onMount } from 'svelte';
</script>

<div class="legal-container">
  <h1>Terms of Service</h1>
  <p class="last-updated">Last Updated: December 18, 2025</p>

  <section>
    <h2>1. Introduction</h2>
    <p>Welcome to SNAP PERK. By accessing or using our website, mobile application, or any other services (collectively, the "Services"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not use our Services.</p>
  </section>

  <section>
    <h2>2. User Accounts</h2>
    <p>You may need to create an account to use some of our Services. You are responsible for safeguarding your account, so use a strong password and limit its use to this account. We cannot and will not be liable for any loss or damage arising from your failure to comply with the above.</p>
  </section>

  <section>
    <h2>3. User Content</h2>
    <p>You retain your rights to any content you submit, post or display on or through the Services. By submitting, posting or displaying content on or through the Services, you grant us a worldwide, non-exclusive, royalty-free license (with the right to sublicense) to use, copy, reproduce, process, adapt, modify, publish, transmit, display and distribute such content in any and all media or distribution methods (now known or later developed).</p>
  </section>

  <section>
    <h2>4. Limitation of Liability</h2>
    <p>To the maximum extent permitted by law, SNAP PERK shall not be liable for any indirect, incidental, special, consequential or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Services.</p>
  </section>

  <div class="footer-note">
  </div>
</div>

<style>
  .legal-container {
    max-width: 800px;
    margin: 2rem auto;
    padding: 2rem;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    line-height: 1.6;
    color: #333;
    text-align: left;
  }

  h1 {
    color: #007bff;
    margin-bottom: 0.5rem;
  }

  .last-updated {
    color: #666;
    font-style: italic;
    margin-bottom: 2rem;
    border-bottom: 1px solid #eee;
    padding-bottom: 1rem;
  }

  h2 {
    font-size: 1.5rem;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    color: #444;
  }

  section {
    margin-bottom: 1.5rem;
  }

  .footer-note {
    margin-top: 3rem;
    padding-top: 1rem;
    border-top: 1px solid #eee;
    text-align: center;
    color: #888;
    font-size: 0.9rem;
  }
</style>